
import HSInlineForm from "./HSInlineForm";


const { register } = require("@lpm/pug-components/dist/register");

register("HSInlineForm/HSInlineForm", HSInlineForm);

